import {
  transactionTableData,
  useTransactionTableColumnsSuspense,
} from "gen/endpoints/transactions/transactions";
import { useTranslation } from "react-i18next";
import { QueryBoundary } from "shared/api/QueryBoundary";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useDataTableServerSideSource } from "shared/components/table/data/DataTableServerSideSource";
import { TableShareStateButton } from "shared/components/table/maybern/MaybernTableBoxActions";
import { useGridStateParam } from "shared/components/table/maybern/MaybernTableGridState";

export const TransactionsListPage = () => {
  const { t } = useTranslation(["common"]);

  const { data } = useTransactionTableColumnsSuspense();
  const datasource = useDataTableServerSideSource(transactionTableData);
  const initialState = useGridStateParam();

  return (
    <PageContainer>
      <PageContent isFullHeight={true}>
        <PageBody>
          <PageHeader title={t("common:transactions")} size="lg" />
          <TableBox isFullWidth={true}>
            <TableBoxHeader>
              <DataTableBoxActions showPivot={true} showExport={false}>
                <TableShareStateButton />
              </DataTableBoxActions>
            </TableBoxHeader>
            <TableBoxBody>
              <QueryBoundary>
                <DataTable
                  data={data}
                  serverSideDatasource={datasource}
                  initialState={initialState}
                  suppressColumnVirtualisation={false}
                />
              </QueryBoundary>
            </TableBoxBody>
          </TableBox>
        </PageBody>
      </PageContent>
    </PageContainer>
  );
};
